import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
    CardsFull,
    Main_,
    On_Click_Card,
    PageAlwaysVisible,
    PageSidebar,
    PageTitle
} from "monica-alexandria";
import { Toolbar_ } from "../../partials/navigation/Toolbar_.jsx";
import { read_niffler_admin_path, read_niffler_leads_path } from "../../../router/niffler_routes";
import styled from "styled-components";

const Panel = styled.div``

/**
 * Renders the Niffler admin landing panel.
 */
export const PANEL = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { lang } = useParams();
    const routeLanguage = lang || "en";
    const [sidebar, setSidebar] = useState(true);

    return (
        <Panel>
            <Toolbar_
                sidebar={sidebar}
                onSidebar={() => setSidebar(!sidebar)}
                routeLanguage={routeLanguage}
                onInternalNavigate={navigate}
            />
            <PageSidebar>
                <PageAlwaysVisible>
                    <PageTitle cta>
                        <h1>{t("Leads")}</h1>
                        <Main_
                            iconLeft="Add"
                            text={t("New lead")}
                            onClick={() => navigate(read_niffler_admin_path(routeLanguage, "new-lead"))}
                        />
                    </PageTitle>
                    <CardsFull>
                        <On_Click_Card
                            onClick={() => navigate(read_niffler_leads_path(routeLanguage))}
                            imgSmall=""
                            title={t("Leads")}
                        />
                        <On_Click_Card
                            onClick={() => navigate(read_niffler_admin_path(routeLanguage, "brands"))}
                            imgSmall=""
                            title={t("Brands")}
                        />
                        <On_Click_Card
                            onClick={() => navigate(read_niffler_admin_path(routeLanguage, "sales"))}
                            imgSmall=""
                            title={t("Sales")}
                        />
                    </CardsFull>
                </PageAlwaysVisible>
            </PageSidebar>
        </Panel>
    );
};
